module.exports = __webpack_public_path__ + "img/empact-logo.06350824.png";